import * as actionTypes from './actions/Actions_name_db'; // IMPORTA LE COSTANTI ACTIONS

const initialState = {
    wallpapers: [],
    category: [],
    lastNum: null,
    error: null,
    loading: false
};

// authStart Handler
const readDataFromFirebaseStart = (state, action) => {
    // console.log("[Reducer] - START - Action READ DATA FROM FIREBASE");
    // return new state in reducer
    const newState = Object.assign({}, state);
    newState.error = null;
    newState.loading = true;
    return newState;
};

const readDataFromFirebaseSuccess = (state, action) => {
    // console.log("[Reducer] - SUCCESS - Action READ DATA FROM FIREBASE");
    // return new state in reducer
    const newState = Object.assign({}, state);
    newState.error = null;
    newState.loading = false;
    newState.wallpapers = action.wallpapers;
    newState.lastNum = action.lastNum;
    return newState;
};

const readDataFromFirebaseFail = (state, action) => {
    // console.log("[Reducer] - Action Error chamata dal reducer Auth")
    // return
    const newState = Object.assign({}, state);
    newState.error = action.error;
    newState.loading = false;
    return newState;
};

const readCategorySuccess = (state, action) => {
    // console.log("[Reducer] - Action Read complete Category");
    const newState = Object.assign({}, state);
    newState.category = action.category;
    return newState;
}

const updateWallpaperSuccess = (state, action) => {
    // console.log("[Reducer] - Action Update complete Wallpaper, aggiorna lo stato");
    const newState = Object.assign({}, state);
    return newState;
}

const deleteWallpaperSuccess = (state, action) => {
    // console.log("[Reducer] - Action Delete complete Wallpaper");
    const newState = Object.assign({}, state);
    newState.wallpapers = action.wallpapers;
    return newState;
}


const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.READ_DATA_START: return readDataFromFirebaseStart(state, action);
        case actionTypes.READ_DATA_SUCCESS: return readDataFromFirebaseSuccess(state, action);
        case actionTypes.READ_DATA_ERROR: return readDataFromFirebaseFail(state, action);

        case actionTypes.READ_CATEGORIE_SUCCESS: return readCategorySuccess(state, action);
        
        case actionTypes.UPDATE_WALLPAPER_SUCCESS: return updateWallpaperSuccess(state, action);
        case actionTypes.DELETE_WALLPAPER_SUCCESS: return deleteWallpaperSuccess(state, action);

        default:
            return state;

    }
};

export default reducer;